import React from 'react';
import { Star } from 'lucide-react';

export function FavoriteStar({ active, onToggle, label }) {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle();
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`kp-nav-fav${active ? ' kp-nav-fav--active' : ''}`}
      aria-label={active ? `Ta bort ${label} från favoriter` : `Lägg till ${label} som favorit`}
      aria-pressed={active}
    >
      <Star size={13} fill={active ? 'currentColor' : 'none'} strokeWidth={2} />
    </button>
  );
}
